import React from 'react';

const LibContext = React.createContext();


export default LibContext;